module.exports = __webpack_public_path__ + "img/affiliate.2f5bbca.webp";